import React, { useEffect, useState } from 'react';
import { Wifi, WifiOff, Gamepad2, X, Database } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

// ============================================================
// OFFLINE ALERT —
//  • Popup modal: "इन्टरनेट जडान विच्छेद भयो…" 
//  • 10 second मा आफैँ hidden + X button पनि छ
//  • Modal भित्रै "खेल खेल्नुहोस्" button (/game — offline चल्छ)
//  • माथि सानो red sticky banner पनि रहन्छ (net farkinca samma)
// ============================================================
const AUTO_HIDE_MS = 10000;

function ConnectionBanner() {
  const navigate = useNavigate();
  const [online, setOnline] = useState(navigator.onLine);
  const [showReconnected, setShowReconnected] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [countdown, setCountdown] = useState(10);

  useEffect(() => {
    const goOffline = () => {
      setOnline(false);
      setModalOpen(true);
    };
    const goOnline = () => {
      setOnline(true);
      if (!navigator.onLine) return;
      setShowReconnected(true);
      setTimeout(() => setShowReconnected(false), 3000);
    };
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    // Page load huda nai offline bhaye pani modal dekhaune
    if (!navigator.onLine) {
      setOnline(false);
      setModalOpen(true);
    }
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  // 10s countdown + auto hide
  useEffect(() => {
    if (!modalOpen) return undefined;
    setCountdown(AUTO_HIDE_MS / 1000);
    const iv = setInterval(() => setCountdown((c) => (c > 0 ? c - 1 : 0)), 1000);
    const t = setTimeout(() => setModalOpen(false), AUTO_HIDE_MS);
    return () => {
      clearInterval(iv);
      clearTimeout(t);
    };
  }, [modalOpen]);

  return (
    <>
      {/* Slim sticky banner — net farkincha samma dekhincha */}
      {!online && (
        <div className="sticky top-0 z-[80] w-full bg-red-600 text-white text-center text-[12.5px] font-bold py-1.5 flex items-center justify-center gap-2 shadow-lg">
          <WifiOff size={14} /> इन्टरनेट जडान विच्छेद भयो — कृपया आफ्नो सञ्जाल जाँच्नुहोस्।
        </div>
      )}

      {/* Reconnect toast */}
      {online && showReconnected && (
        <div
          className="fixed top-4 left-1/2 -translate-x-1/2 z-[85] bg-green-600 text-white text-[12.5px] font-bold px-5 py-2.5 rounded-full shadow-xl flex items-center gap-2 animate-[fadeInDown_0.3s_ease-out]"
          role="status"
        >
          <Wifi size={14} /> इन्टरनेट फेरि जोडियो!
        </div>
      )}

      {/* OFFLINE POPUP MODAL */}
      {modalOpen && (
        <div className="fixed inset-0 z-[95] flex items-center justify-center p-4">
          {/* Backdrop — click garda pani band */}
          <div
            className="absolute inset-0 bg-black/60 backdrop-blur-sm"
            onClick={() => setModalOpen(false)}
            aria-hidden="true"
          />

          <div className="relative bg-white rounded-2xl shadow-2xl border border-line w-full max-w-[380px] overflow-hidden">
            {/* Top strip */}
            <div className="bg-gradient-to-br from-red-600 to-red-700 text-white px-6 pt-6 pb-5 text-center relative">
              <button
                className="absolute top-3 right-3 inline-flex items-center justify-center w-9 h-9 rounded-[10px] bg-white/15 hover:bg-white/30 transition-colors"
                onClick={() => setModalOpen(false)}
                aria-label="बन्द गर्नुहोस्"
              >
                <X size={18} />
              </button>
              <span className="inline-flex w-14 h-14 rounded-full bg-white/15 items-center justify-center mb-3">
                <WifiOff size={26} />
              </span>
              <h3 className="font-display text-[18px] font-bold leading-snug">
                इन्टरनेट जडान विच्छेद भयो
              </h3>
              <p className="text-[12.5px] text-white/85 mt-1">कृपया आफ्नो सञ्जाल जाँच्नुहोस्।</p>
            </div>

            <div className="p-5 sm:p-6 flex flex-col gap-3">
              <p className="text-[12.5px] text-muted flex items-start gap-2 m-0">
                <Database size={14} className="mt-0.5 flex-shrink-0 text-emerald-600" />
                पहिले हेरेका समाचारहरू क्यासबाट तुरुन्तै लोड हुन्छन्।
              </p>

              <button
                type="button"
                className="w-full inline-flex items-center justify-center gap-2 bg-emerald-700 text-white font-bold text-[13.5px] px-5 py-3 rounded-xl hover:bg-emerald-800 transition-colors shadow-md shadow-emerald-700/20"
                onClick={() => {
                  setModalOpen(false);
                  navigate('/game');
                }}
              >
                <Gamepad2 size={17} /> खेल खेल्नुहोस् — टिक ट्याक टो
              </button>

              <p className="text-center text-[11px] text-muted m-0">
                यो सन्देश <span className="font-bold text-ink">{countdown}s</span> मा आफैँ हराउँछ
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ConnectionBanner;
